import { MaterialIcon } from '../../../MaterialIcon';
import { ProductDetailsAttributeGroups } from '../../BaseComponents/ProductDetailsAttributeGroups';
import { ProductDetailsSectionHeader } from '../../BaseComponents/ProductDetailsSectionHeader';
import type { ConfiguredSectionProps } from './types';

/**
 * Default configured section (STK / BKA): section header + one card per attribute group. Slots whose
 * content is not only attribute groups have their own component (Offers, Highlights).
 */
export const ProductDetailsSectionConfigured: React.FC<
  ConfiguredSectionProps
> = (section) => (
  <div className="flex flex-col gap-6" data-component="pdp-configured-section">
    <ProductDetailsSectionHeader
      icon={<MaterialIcon icon={section.icon} size={3} />}
    >
      {section.label}
    </ProductDetailsSectionHeader>
    <ProductDetailsAttributeGroups
      groups={section.groups}
      sectionTitle={section.label}
      product={section.product}
      pushDataLayer={section.pushDataLayer}
    />
  </div>
);
